import { icons } from '@sixfold/icons';
import classnames from 'classnames';
import * as React from 'react';
import '../theme/index.js';
import { icon, color } from './icon.css.js';
export { IconEUFlag } from './icon_eu_flag.js';
import { useTheme } from '../theme/use_theme.js';

const availableIconsByName = icons.reduce((memo, icon) => {
    return {
        ...memo,
        [icon.name]: {
            width: icon.width,
            height: icon.height,
        },
    };
}, {});
const Icon = React.memo(function Icon({ className, size, name, color: propsColor, kind, prominence, ...rest }) {
    const { getIconPath } = useTheme();
    if (name === undefined) {
        return null;
    }
    const iconPath = getIconPath(name);
    const { width: defaultWidth, height: defaultHeight } = availableIconsByName[name] ?? { width: size, height: size };
    const color$1 = kind === undefined && prominence === undefined ? 'inherit' : `${kind ?? 'neutral'}-${prominence ?? 'subtle'}`;
    return (React.createElement("svg", { ...rest, width: size ?? defaultWidth, height: size ?? defaultHeight, className: classnames(icon, color[color$1], className), style: propsColor ? { color: propsColor } : undefined, focusable: "false" },
        React.createElement("use", { href: iconPath })));
});

export { Icon };
